import { gql, useQuery } from "@apollo/client";
import React, { useContext, useEffect } from "react";
import { PageContext } from "./../../context/PageContext";
import { MetaTags } from "react-meta-tags";
import { PrivateBookingBanner } from "./Banner";
import { PrivateBookingList } from "./List";
import { Helmet } from "react-helmet";

const GET_PRIVATE_BOOKING_PAGE = gql`
  query PrivateBookingPage {
    page(id: "tug-private-events", idType: URI) {
      privateEvents {
        banner {
          mediaItemUrl
        }
        description
      }
    }
  }
`;
const PrivateBooking = () => {
  const { handleNavLoad, brand, common, sample, ico } = useContext(PageContext);
  const images = { brand, common, sample, ico };
  const { data } = useQuery(GET_PRIVATE_BOOKING_PAGE);
  useEffect(() => {
    handleNavLoad(true);
  }, []);
  return (
    <>
      <MetaTags>
        <title>The Union Group - Private Booking</title>
        <meta name="keywords" content="private booking union group" />
        <meta name="description" content="What's On in The Union Group" />
        <meta property="og:title" content="The Union Group - Private Booking" />
        <meta
          property="og:description"
          content="Casual or formal, The Union Group has the perfect venue to make your occasion unforgettable."
        />
        <meta property="og:image" content={images.ico["richlink.jpg"]} />
      </MetaTags>
      <Helmet>
        <body className="bd-private-booking" />
      </Helmet>
      <PrivateBookingBanner
        banner={data?.page?.privateEvents?.banner?.mediaItemUrl}
        description={data?.page?.privateEvents?.description}
      />
      <PrivateBookingList />
    </>
  );
};

export default PrivateBooking;
